import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=140caff8&"
import script from "./TransactionForm.vue?vue&type=script&lang=js&"
export * from "./TransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports